import { useContext } from 'react';
import { AppStateContext } from './AppStateContext';

export const useAppState = () => {
  const appState = useContext(AppStateContext);

  if (!appState) {
    throw new Error('App state context not initialized!');
  }

  return appState;
};
